import httpClient from "./httpClient";

const prefix = "/sizes";

export async function readSizes() {
  return (await httpClient.get(`${prefix}`)).data;
}
